import { call, get, sync } from "vuex-pathify"
import ClientMenuMixin from "./mixin"

export default {
    props: {
        clients: {
            type: Array,
            default: []
        },
    },

    mixins: [ClientMenuMixin],

    data() {
        return {
            clientPermissions: []
        }
    },

    computed: {
        hasClients() {
            return this.clients && this.clients.length > 0
        },

        showClients() {
            if (this.clientPermissions.length !== this.clients.length) {
                return false
            }

            return this.clientPermissions.length > 1
        },
    },

    watch: {
        currentClient(newValue, oldValue) {
            if (this.isLoggedIn) {
                this.loadClients()
            }
        },

        async clients(newValue, oldValue) {
            if (newValue !== oldValue ) {
                await this.canUpdateClients()
            }
        }
    },

    async mounted() {
        if (this.clients.length > 0) {
            await this.canUpdateClients()
        }
    },

    methods: {
        can: call('auth/can'),
        loadCharts: call('charts/loadCharts'),

        canUpdateClient(client_id) {
            let client = this.clientPermissions.find(clientPermission => clientPermission.id === client_id)

            if (client && client.canUpdate) {
                return true
            }

            return false
        },

        async canUpdateClients() {
            let clients = []

            for (const client of this.clients) {
                let allowed = await this.can({ability: 'update', model: 'clients', id: client.id})

                clients.push({id: client.id, canUpdate: allowed})
            }

            this.clientPermissions = clients
        },

        async onSelectClient(client) {
            this.currentClient = client
            await this.loadCharts()
        },
    },

    render() {
        return this.$scopedSlots.default({
            canUpdateClient: this.canUpdateClient,
            clients: this.clients,
            currentClient: this.currentClient,
            hasClients: this.hasClients,
            loadCharts: this.loadCharts,
            onSelectClient: this.onSelectClient,
            showClients: this.showClients,
        })
    },
}
